import {
  core_v1_DataSource,
  coreV1GetDataSourceOptions,
  coreV1GetDataSourceQueryKey,
} from '@antimatterhq/asl-api-ts-v1';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { useValueWithSuspense } from '@antimatterhq/ui/hooks/suspense/useValueWithSuspense';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetDatasourceWithSuspense = ({ name }: { name: string }) => {
  const workspaceContext = useWorkspace();
  const workspace = useValueWithSuspense(workspaceContext.workspace);

  return useSuspenseQuery({
    ...coreV1GetDataSourceOptions({
      ...defaultOptions(),
      path: { workspace, name },
    }),
  });
};

export const useGetDatasource = ({
  name,
  disabled = false,
}: {
  name: string;
  disabled?: boolean;
}) => {
  const { workspace } = useWorkspace();

  return useQuery({
    ...coreV1GetDataSourceOptions({
      ...defaultOptions(),
      path: { workspace, name },
    }),
    enabled: !disabled && !!name && !!workspace,
  });
};

export const useOptimisticUpdateGetDataSource = () => {
  const { workspace } = useWorkspace();
  const queryClient = useQueryClient();

  return ({
    data,
    name,
  }: {
    data: core_v1_DataSource | undefined;
    name: string;
  }) => {
    queryClient.setQueryData(
      coreV1GetDataSourceQueryKey({
        ...defaultOptions(),
        path: { workspace, name },
      }),
      data,
    );
  };
};
